// Module
var code = `<div class="input">
  <button>Click Here</button>
  <input placeholder="Enter Text" type="text" />
</div>

<h3 class="output">Output</h3>
`;
// Exports
module.exports = code;